import type { Environment } from './environment.model';

export const environment: Environment = {
  production: false,
  name: 'development',
  apiUrl: 'https://develop.celeri.today/api/v1',
  platform: 'web',
  logLevel: 'debug',
  tokenStorage: 'local',
  nominatimUrl: 'https://nominatim.openstreetmap.org/search',
};
